// --- utils
import { map } from "lodash-es";

// --- types
import type { ICountry } from "@upmind-automation/types";
import type { JsonSchema7, UISchemaElement } from "@jsonforms/core";

export const useSchema = ({ country }: { country?: ICountry }): JsonSchema7 => {
  const schema: JsonSchema7 = {
    type: "object",
    title: "Phone Number",
    required: ["phone"],
    properties: {
      id: {
        type: ["string", "null"],
        title: "ID",
        description: "The AutoGenerated ID of this Phone.",
        readOnly: true
      },

      phone: {
        type: "object",
        // @ts-expect-error: 'phone_country_code' is a custom AJV keyword
        phone_country_code: country?.code,
        required: ["number", "nationalNumber", "countryCallingCode", "country"],
        properties: {
          number: {
            type: "string",
            title: "Phone number ( with dialing code )"
          },

          nationalNumber: {
            type: "string",
            title: "Phone number"
          },

          countryCallingCode: {
            type: "string",
            title: "Country calling code"
          },

          country: {
            type: "string",
            title: "Country",
            default: country?.code || null
          }
        }
      }

      //  --- deprecated

      // type: {
      //   type: "number",
      //   const: 1,
      //   readOnly: true,
      // },

      // default: {
      //   type: ["boolean", "null"],
      //   title: "Make this the default phone?",
      // },
    }
    // errorMessage: {
    //   properties: {
    //     phone: "must be a valid phone number"
    //   }
    // }
  };

  return schema;
};

export const useUischema = () => {
  const schema = {
    type: "VerticalLayout",
    elements: [
      // {
      //   type: "Control",
      //   scope: "#/properties/id",
      //   rule: {
      //     effect: "HIDE",
      //     condition: { const: true },
      //   },
      // }, // HACK: need to force hide this otherwise the id renders in hte email field?

      {
        type: "Control",
        scope: "#/properties/phone",
        i18n: "form.phone",
        options: {
          autoFocus: true,
          autocomplete: "phone"
        }
      }
    ]
  };

  return schema as UISchemaElement;
};
